
    import "src/app/Auth/ForgotPassword/index.module.scss?farm_css_modules";
    
    export default {"formComponent": `formComponent-2b48fd68`,"leftComponent": `leftComponent-2b48fd68`,"leftTitle": `leftTitle-2b48fd68`,"otpInputStyle": `otpInputStyle-2b48fd68`,"resendOTP": `resendOTP-2b48fd68`,"rightComponent": `rightComponent-2b48fd68`,"topLogoImage": `topLogoImage-2b48fd68`}
    